/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userTransferMessages.internal

import features.userTransferMessages.models.TransferMessagesModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class TransferMessagesServiceImpl : TransferMessagesService {

    private val transferMessagesRequest = TransferMessagesRequest()

    override suspend fun getTransferMessages(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<TransferMessagesModel> {
        return transferMessagesRequest.getTransferMessages(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
